/* unplugin-vue-components disabled */import { render } from "./LoveStrategy.vue?vue&type=template&id=11fd85be&scoped=true"
import script from "./LoveStrategy.vue?vue&type=script&lang=js"
export * from "./LoveStrategy.vue?vue&type=script&lang=js"

import "./LoveStrategy.vue?vue&type=style&index=0&id=11fd85be&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fd85be"]])

export default __exports__